'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _button = require('../../../atoms/button');

var _button2 = _interopRequireDefault(_button);

var _divider = require('../../divider');

var _divider2 = _interopRequireDefault(_divider);

var _jump = require('../js/jump');

var _jump2 = _interopRequireDefault(_jump);

var _breakpoints = require('../../../../utilities/breakpoints');

var _breakpoints2 = _interopRequireDefault(_breakpoints);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ORGANISM_NAME = 'in-page-anchors';
var SCROLL_OFFSET = -72;

var InPageAnchors = function (_React$Component) {
  _inherits(InPageAnchors, _React$Component);

  function InPageAnchors(props) {
    _classCallCheck(this, InPageAnchors);

    var _this = _possibleConstructorReturn(this, (InPageAnchors.__proto__ || Object.getPrototypeOf(InPageAnchors)).call(this, props));

    _this.renderCta = function (cta) {
      if (cta && cta.text) {
        var targetValue = cta.target || '_self';

        return _react2.default.createElement(
          _button2.default,
          {
            id: cta.id,
            href: cta.href,
            color: cta.color || 'blue',
            className: ORGANISM_NAME + '__cta',
            fpti: 'InPgAchrs-' + (cta.type || 'cta') + '-' + (cta.fpti || cta.text),
            target: targetValue
          },
          cta.text
        );
      }
      return null;
    };

    _this.state = {
      blurred: false,
      containerIds: [],
      isMobile: false,
      isSticky: false,
      isScrolling: false,
      isTabing: true,
      selectedLink: '',
      showDropdown: true
    };

    _this.bodyRef = undefined;
    _this.isStickyHeader = false;
    _this.isCanvas = undefined;

    _this.handleBlur = _this.handleBlur.bind(_this);
    _this.handleHighlightLink = _this.handleHighlightLink.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    _this.handleLink = _this.handleLink.bind(_this);
    _this.handleResize = _this.handleResize.bind(_this);
    _this.handleScroll = _this.handleScroll.bind(_this);
    _this.handleTouchOutside = _this.handleTouchOutside.bind(_this);
    _this.renderLinks = _this.renderLinks.bind(_this);
    _this.setContainerIds = _this.setContainerIds.bind(_this);
    return _this;
  }

  _createClass(InPageAnchors, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setBodyRef();
      window.addEventListener('resize', this.handleResize);
      window.addEventListener('scroll', this.handleScroll);
      window.addEventListener('touchend', this.handleTouchOutside);
      this.handleResize();
      this.setContainerIds(this.props.content.links);

      // TODO: generate custom canvas scroll event to prime anchor scrolling

      // check if sticky-header is present
      this.isStickyHeader = !!document.getElementsByClassName('pp-header--fixed')[0] || !!this.bodyRef.querySelector('.pp-header--fixed');
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('touchend', this.handleTouchOutside);
    }
  }, {
    key: 'setBodyRef',
    value: function setBodyRef() {
      /*
      * This method is used to find the closest BODY parent to the header
      * and is needed since sometimes we need to find DOM elements
      * inside an iFrame(due to Canvas platform); in this case, we want to
      * be able to find the header to know if it is sticky or not.
      */
      var currentRef = this.inPageAnchorsContainer.parentNode;
      while (!this.bodyRef && currentRef) {
        if (currentRef.tagName === 'BODY') {
          this.bodyRef = currentRef;
        } else {
          currentRef = currentRef.parentNode;
        }
      }
      this.bodyRef = this.bodyRef || document.body;
    }
  }, {
    key: 'setContainerIds',
    value: function setContainerIds(links) {
      this.setState({ containerIds: links.map(function (link) {
          return link.href;
        }) });
    }
  }, {
    key: 'handleResize',
    value: function handleResize() {
      var newWindowWidth = Math.min(this.inPageAnchorsContainer.ownerDocument.defaultView.innerWidth, this.inPageAnchorsContainer.ownerDocument.documentElement.clientWidth, this.inPageAnchorsContainer.ownerDocument.body.clientWidth);
      if (newWindowWidth >= _breakpoints2.default.large) {
        if (this.state.isMobile) {
          this.setState({
            isMobile: false,
            showDropdown: true
          });
        }
      } else if (!this.state.isMobile) {
        this.setState({
          isMobile: true,
          showDropdown: false
        });
      }
    }
  }, {
    key: 'handleScroll',
    value: function handleScroll(e) {
      var distanceFromTop = this.inPageAnchorsContainer.getBoundingClientRect().top;

      // we check existence of a custom attribute from canvas
      this.isCanvas = typeof e.iFrameScrollY === 'number';

      this.setState({
        isSticky: distanceFromTop <= 0,
        isTabing: false
      });

      this.handleHighlightLink();
    }
  }, {
    key: 'handleTouchOutside',
    value: function handleTouchOutside(e) {
      if (e.target.classList.contains(ORGANISM_NAME + '__link')) {
        if (this.state.isMobile && this.state.showDropdown) {
          this.setState({
            showDropdown: !this.state.showDropdown,
            blurred: true
          });
        }
      }
    }
  }, {
    key: 'handleDropdownArrow',
    value: function handleDropdownArrow(fireTracking, e) {
      var buttonState = this.state.blurred ? 'close' : 'open';
      var fptiValue = 'InPgAchrs-btn-' + buttonState;

      e.preventDefault();

      fireTracking(fptiValue);

      this.setState({
        showDropdown: !this.state.showDropdown,
        blurred: !this.state.blurred
      });
    }
  }, {
    key: 'handleBlur',
    value: function handleBlur(e) {
      var _this2 = this;

      if (this.state.isMobile) {
        var currentTarget = e.currentTarget;

        setTimeout(function () {
          if (!currentTarget.contains(document.activeElement)) {
            _this2.setState({
              showDropdown: false,
              blurred: true
            });
          }
        }, 0);
      }
    }
  }, {
    key: 'handleHighlightLink',
    value: function handleHighlightLink() {
      var visibleSectionId = '';

      this.state.containerIds.forEach(function (id) {
        var scrollTop = void 0;
        var scrollBottom = void 0;
        try {
          scrollTop = document.querySelector(id).getBoundingClientRect().top;
          scrollBottom = document.querySelector(id).getBoundingClientRect().bottom;
        } catch (e) {
          // do nothing
        }

        if (!Number.isNaN(scrollTop) && // id matched html element
        scrollTop - 1 < 0 - SCROLL_OFFSET && scrollBottom - 1 > 0 - SCROLL_OFFSET) {
          visibleSectionId = id;
        }
      });

      this.setState({ selectedLink: visibleSectionId });
    }
  }, {
    key: 'handleLink',
    value: function handleLink(fireTracking, e) {
      var _this3 = this;

      var target = e.currentTarget;
      var targetHref = target.href.split('#')[1];

      var jumpToElement = targetHref && (document.getElementById(targetHref) || this.bodyRef.querySelector('#' + targetHref));

      // TODO: hack to make scrolling work on canvas
      // need to find a way to get this hardcoded query elsewhere
      // or, enhance scroll to work seamlessly inside iframes
      var iframeWindow = this.isCanvas ? document.querySelector('.central-panel iframe').contentWindow : undefined;

      var fptiValue = 'InPgAchrs-Link-#' + targetHref;

      var setScrollingState = function setScrollingState() {
        _this3.setState({ isScrolling: false });
      };

      // allow native link behavior for ie <= 9
      if (window.requestAnimationFrame) e.preventDefault();

      fireTracking(fptiValue);

      if (jumpToElement && !this.state.isScrolling) {
        this.setState({ isScrolling: true });

        (0, _jump2.default)({
          target: jumpToElement,
          offset: SCROLL_OFFSET,
          duration: 500,
          callback: setScrollingState,
          windowObj: iframeWindow
        });
      }

      this.setState({
        // only close when on mobile view
        showDropdown: !this.state.isMobile,
        blurred: true
      });
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(e) {
      // esc key
      if (e.keyCode === 27) {
        this.setState({
          showDropdown: false,
          blurred: true
        });
      }
      // tab key
      if (e.keyCode === 9) {
        this.setState({
          isTabing: true
        });
      }
    }

    // onClick is intentionally binded like this in order to pass in 2 parameters

  }, {
    key: 'renderLinks',
    value: function renderLinks(links, fireTracking) {
      var _this4 = this;

      if (!links) return null;

      return links.map(function (link, idx) {
        var _cx;

        var linkClasses = (0, _classnames2.default)(ORGANISM_NAME + '__link', (_cx = {}, _defineProperty(_cx, ORGANISM_NAME + '__link--selected', _this4.state.selectedLink !== '#' && link.href === _this4.state.selectedLink), _defineProperty(_cx, ORGANISM_NAME + '__link--underline', _this4.state.isTabing), _cx));

        // used index in key just in case that href is the same
        var key = '' + idx + link.href;

        return _react2.default.createElement(
          'li',
          { className: ORGANISM_NAME + '__li', key: key },
          _react2.default.createElement(
            'a',
            {
              className: linkClasses,
              href: link.href,
              onClick: function onClick(e) {
                return _this4.handleLink(fireTracking, e);
              },
              tabIndex: _this4.state.blurred && _this4.state.isMobile ? '-1' : ''
            },
            link.text
          )
        );
      });
    }

    // onClick is intentionally binded like this in order to pass in 2 parameters

  }, {
    key: 'renderDropdownButton',
    value: function renderDropdownButton(content, classes, cta, fireTracking) {
      var _this5 = this;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'button',
          {
            className: classes,
            onClick: function onClick(e) {
              return _this5.handleDropdownArrow(fireTracking, e);
            }
          },
          _react2.default.createElement(
            'span',
            { className: ORGANISM_NAME + '__dropdown-button__text' },
            this.state.showDropdown ? content.close.text : content.open.text
          )
        ),
        content.label && !cta && _react2.default.createElement(
          'span',
          { className: ORGANISM_NAME + '__dropdown-button__label' },
          content.label.text
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _cx3,
          _this6 = this;

      var _props$content = this.props.content,
          primaryCta = _props$content.primaryCta,
          links = _props$content.links,
          dropdownButton = _props$content.dropdownButton;
      var _props$config = this.props.config,
          id = _props$config.id,
          buttonAlign = _props$config.buttonAlign;
      var _state = this.state,
          isMobile = _state.isMobile,
          isSticky = _state.isSticky,
          showDropdown = _state.showDropdown;


      var navClasses = (0, _classnames2.default)(ORGANISM_NAME + '__nav', _defineProperty({}, ORGANISM_NAME + '__nav--sticky', this.state.isSticky && !this.isStickyHeader));

      var optionsClasses = (0, _classnames2.default)(ORGANISM_NAME + '__link-list', (_cx3 = {}, _defineProperty(_cx3, ORGANISM_NAME + '__link-list--slide-down', showDropdown && isMobile), _defineProperty(_cx3, ORGANISM_NAME + '__link-list--text-right', !isMobile && buttonAlign === 'left'), _cx3));

      var linksContainerClasses = (0, _classnames2.default)(ORGANISM_NAME + '__links-container', _defineProperty({}, ORGANISM_NAME + '__links-container--text-right', !isMobile && buttonAlign === 'left'));

      var flexWrapperClasses = (0, _classnames2.default)(ORGANISM_NAME + '__flex-wrapper', _defineProperty({}, ORGANISM_NAME + '__flex-wrapper--button-left', !isMobile && buttonAlign === 'left'));

      var dropdownButtonClasses = (0, _classnames2.default)(ORGANISM_NAME + '__dropdown-button', _defineProperty({}, ORGANISM_NAME + '__dropdown-button--show-x', showDropdown));

      // fireTracking is passed into render methods below so that the component
      // will still be able to use fireTracking when it is extended
      return _react2.default.createElement(
        'section',
        {
          id: id,
          'data-building-block': 'organism',
          className: ORGANISM_NAME,
          ref: function ref(element) {
            _this6.inPageAnchorsContainer = element;
          }
        },
        _react2.default.createElement(
          'nav',
          { className: navClasses },
          _react2.default.createElement(
            'div',
            { className: ORGANISM_NAME + '__container' },
            _react2.default.createElement(
              'div',
              { className: flexWrapperClasses },
              this.props.children ? this.props.children : _react2.default.createElement(
                'div',
                {
                  className: linksContainerClasses,
                  onKeyDown: this.handleKeyDown,
                  onBlur: this.handleBlur,
                  role: 'button',
                  tabIndex: '-1'
                },
                isMobile && this.renderDropdownButton(dropdownButton, dropdownButtonClasses, primaryCta, this.props.fireTracking),
                _react2.default.createElement(
                  'ul',
                  { className: optionsClasses },
                  this.renderLinks(links, this.props.fireTracking)
                )
              ),
              isSticky && this.renderCta(primaryCta)
            )
          )
        ),
        _react2.default.createElement(_divider2.default, null)
      );
    }
  }]);

  return InPageAnchors;
}(_react2.default.Component);

exports.default = InPageAnchors;


InPageAnchors.propTypes = {
  config: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    buttonAlign: _propTypes2.default.oneOf(['left', 'right'])
  }),
  content: _propTypes2.default.shape({
    dropdownButton: _propTypes2.default.shape({
      label: _propTypes2.default.shape({
        text: _propTypes2.default.string.isRequired
      }),
      open: _propTypes2.default.shape({
        text: _propTypes2.default.string.isRequired
      }).isRequired,
      close: _propTypes2.default.shape({
        text: _propTypes2.default.string.isRequired
      }).isRequired
    }).isRequired,
    links: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired,
      href: _propTypes2.default.string.isRequired
    }).isRequired),
    primaryCta: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired,
      href: _propTypes2.default.string.isRequired,
      id: _propTypes2.default.string,
      target: _propTypes2.default.oneOf(['_self', '_blank'])
    })
  }),
  children: _propTypes2.default.node,
  fireTracking: _propTypes2.default.func
};

InPageAnchors.defaultProps = {
  config: {
    id: '',
    buttonAlign: 'right'
  },
  content: {
    dropdownButton: {
      label: {
        text: 'Sections'
      },
      open: {
        text: 'Expand more'
      },
      close: {
        text: 'Expand less'
      }
    },
    links: [{
      text: '16 characters maximum',
      href: '#'
    }, {
      text: '16 characters maximum',
      href: '#'
    }, {
      text: '16 characters maximum',
      href: '#'
    }, {
      text: '16 characters maximum',
      href: '#'
    }],
    primaryCta: {
      id: '',
      href: '#',
      text: '18 characters maximum',
      target: '_self'
    }
  },
  fireTracking: function fireTracking() {},
  children: null
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/in-page-anchors/jsx/InPageAnchors.js
// module id = 1106
// module chunks = 4